import isEnabled from '../services/is-experiment-enabled';
export var getExperiments = function (state) { return state.experiments; };
export var isExperimentEnabled = function (state, name, value) {
    return isEnabled(getExperiments(state), name, value);
};
